import React, { useState, useEffect } from 'react';

import axios from 'axios';
import {CarouselProvider, DotGroup, Slide, Slider} from "pure-react-carousel";
import {default as renderDots} from './Pagination';
import 'pure-react-carousel/dist/react-carousel.es.css';
import {filterAthletes} from "../helper";

function OverallLeaderboard (props) {

    const [leaderboard, setLeaderboard] = useState([]);

    const [slides, setSlides] = useState([]);

    const [filtered, setFiltered] = useState([]);

    const perPage = 25;

    useEffect(() => {

        axios.get(`/api/athletes?gender=${props.gender}`)
            .then(result => {

                setLeaderboard(result.data);

                return result;

            })
            .catch(error => console.log(error));

    }, []);

    useEffect(() => {

        const searchArray = props.searchString.toLowerCase().split(',');

        const f = leaderboard.filter((athlete) => filterAthletes(athlete.fullname, searchArray))//.sort((a, b) => b.points - a.points);

        const s = [];

        for (let i = 0; i < f.length/perPage; i++) {

            s.push(i);

        }

        setSlides(s);

        setFiltered(f);

    }, [leaderboard, props.searchString]);

    return (
        <div>
            <div className="d-flex align-items-center">
                <h3 className={'mr-3'}>{props.gender === 'M' ? 'Buaba' : 'Mädla'}</h3>
                <span className={'mr-auto'}>{leaderboard.length} gesamt</span>
            </div>

            <table className={'table mb-0'}>

                <thead>
                <tr>
                    <th className={'w-12'}>Platz</th>
                    <th className={'w-63'}>Name</th>
                    <th className={'w-25'}>Punkte</th>
                </tr>
                </thead>
            </table>

            <CarouselProvider
                naturalSlideWidth={100}
                naturalSlideHeight={200}
                totalSlides={slides.length}
                isIntrinsicHeight={true}
            >
                <Slider>

                    {slides.map((slide, i) => <Slide index={i} key={i}>
                        <table className={'table'}>

                            <thead style={{visibility: 'collapse', maxHeight: '0px'}}>
                            <tr>
                                <th className={'w-12'}>Platz</th>
                                <th className={'w-63'}>Name</th>
                                <th className={'w-25'}>Punkte</th>
                            </tr>
                            </thead>

                            <tbody>
                            {filtered.slice(slide*perPage, (slide+1)*perPage).map((entry, i) => (
                                <tr key={i}>
                                    <td>{entry.rank}</td>
                                    <td>{entry.fullname}</td>
                                    <td>{entry.total}</td>
                                </tr>

                            ))}
                            </tbody>
                        </table>
                    </Slide>)}
                </Slider>

                <DotGroup renderDots={renderDots}></DotGroup>

            </CarouselProvider>

        </div>
    );
}

export default OverallLeaderboard;
